<div class="container">
  <div class="left">
    <div class="title">JOIN THE 2000+ VENUES ON {{ PRODUCT_NAME }}</div>
    <div class="blurb">
      It's a party, and you're invited. {{ PRODUCT_NAME }} helps you close more sales, efficiently collaborate with your teams and vendors,
      and plan inspiring events for all of your clients.
    </div>
    <a
      class="learn-more-link"
      mat-stroked-button
      [routerLink]="LEARN_MORE_VENUE_LINK"
      rel="noopener nofollow noreferrer"
      merriNoFocusLink
    >
      <span class="learn-more-link-label">Learn More</span>
    </a>
  </div>
  <div class="right">
    <div class="image-wrapper">
      <img
        [src]="imageUrl"
        imgErrLog
      />
    </div>
  </div>
</div>
